<template>
    <div>
        <div class="row-content mb10">
            <div class="row-item column-layout flex">
                <div class="fl col-5">
                    <span>员工所在公司：</span>
                    <span>{{staffInfo.comName || ""}}</span>
                </div>
                <div class="fl col-5">
                    <span>员工名称：</span>
                    <span>{{staffInfo.name || ""}}</span>
                    <a class="swb-btn  swb-btn-link" v-if="showChangeStaff" @click="staffForselect()">选择</a>
                </div>
                <div class="fl col-2">
                    <a class="swb-btn  swb-btn-link fr" :class="btnState? '':'swb-btn-disabled'" :title="btnState? '':'暂未订阅'" v-if="thisStaffId != null">
                        <span v-if="btnState" @click="showEventMsgSubscrList()">查看已订阅</span>
                        <span v-else>查看已订阅</span>
                    </a>
                </div>
            </div>

        </div>
        <div class="column-layout flex">

            <div class="fl col-3 pr20">
                <swb-org-tree class="msg-subscr"  :accordion="true" :isShowIcon="false" @notity-change="notityChange($event)" ref="swb_org_tree"></swb-org-tree>
            </div>

            <div class="fl col-9">
                <div style="background-color: #E6F3FC;padding: 5px 10px;margin: 10px 0">
                    <!--<el-checkbox class="ml20" v-if="!(bizEventMsg.goodsRelated && bizEventMsg.servcRelated)" v-model="thisComSelect"></el-checkbox>-->
                    <span class="font-gray2">当前订阅公司：</span>
                    <span v-if="comName == null" class="font-red">未选择</span>
                    <span class="font-block font-bold" v-else>{{comName}}</span>
                    <el-tag type="success" v-if="thisComSelect">已订阅</el-tag>
                </div>
                <div class="row-content ">
                    <div class="row-item column-layout flex">
                        <div class="fl col-3">
                            <span>消息主题：</span>
                            <span>{{bizEventMsg.topicName}}</span>
                        </div>
                        <div class="fl col-3 ellipsis-1 pr5">
                            <span>事件名称：</span>
                            <span :title="bizEventMsg.name">{{bizEventMsg.name}}</span>
                        </div>
                        <div class="fl col-6">
                            <span>支持方式：</span>
                            <el-checkbox class="ml20" v-model="siteMsgFlag" v-if="bizEventMsg.siteMsgFlag" @change="changeSaveFlag">站内信</el-checkbox>
                            <el-checkbox class="ml20" v-model="emailFlag" v-if="bizEventMsg.emailFlag" @change="changeSaveFlag">邮箱</el-checkbox>
                            <el-checkbox class="ml20" v-model="wxFlag" v-if="bizEventMsg.wxFlag" @change="changeSaveFlag">微信</el-checkbox>
                            <span class="mr5" v-if="!bizEventMsg.siteMsgFlag && !bizEventMsg.emailFlag && !bizEventMsg.wxFlag">无</span>
                        </div>
                    </div>
                </div>
                <div class="row-content mt5" v-if="wxFlag">
                    <div class="row-item column-layout flex">
                        <div class="fl col-12">
                            <span>订阅小程序：</span>
                            <el-checkbox v-model="selectMiniApp" @change="changeSaveFlag">选择小程序</el-checkbox>
                            <div v-if="selectMiniApp" class="inline-block">
                                <div class="inline-block ml10" v-if="bizEventMsgAppList != null && bizEventMsgAppList.length > 0">
                                    <el-radio-group v-model="appAlias" @change="changeSaveFlag">
                                        <el-radio v-for="eventMsgApp in bizEventMsgAppList" :label="eventMsgApp.appAlias">
                                            <span>{{miniAppAliases[eventMsgApp.appAlias]}}</span>
                                        </el-radio>
                                    </el-radio-group>
                                </div>
                                <span class="font-red ml10" v-else>未设置小程序</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="min-height: 100px" v-if="bizEventMsg.goodsRelated">
                    <div class="content-caption dashed">
                        <span>商品分类</span>
                        <el-checkbox class="ml20" v-model="goodsCatForAll" @change="goodsCatSet()">全部分类</el-checkbox>
                        <a class="fr swb-btn swb-btn-link mt10" v-if="!goodsCatForAll" @click="goodsCatForselect()">选择</a>
                    </div>
                    <ul class="switch-list clearfix">
                        <li class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;" v-for="goodsCat in goodsCatList">
                            <a>{{goodsCat.catName}}</a>
                        </li>
                    </ul>
                </div>
                <div style="min-height: 100px" v-if="bizEventMsg.servcRelated">
                    <div class="content-caption dashed">
                        <span>服务分类</span>
                        <el-checkbox class="ml20" v-model="servcCatForAll" @change="servcCatSet()">全部分类</el-checkbox>
                        <a class="fr swb-btn swb-btn-link mt10" v-if="!servcCatForAll" @click="servcCatForselect()">选择</a>
                    </div>
                    <ul class="switch-list clearfix">
                        <li class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;" v-for="servcCat in servcCatList">
                            <a>{{servcCat.catName}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import {
        openCategTreeMultiSelectDlg,
        openServcCategTreeMultiSelectDlg,
        openMerchtFusedGoodsCategSelectDlg,
        openMerchtFusedServcCategSelectDlg
    } from '../categ/selectDlg'
    import { openThisOrDownComStaffForSelectDlg } from '../orgStruct/selectDlg'
    import { showEventMsgSubscrListDlg } from '../bizMsg/dialog'
    //
    import bizMsgApi from '../../api/bizMsg'
    import userApi from '../../api/user'
    import servicerApi from '../../api/servicer'
    //
    import SwbOrgTree from '../orgStruct/OrgTree';
    Vue.regist(SwbOrgTree);

    export default {
        name: 'swb-msg-subscr-dlg',
        desc: ' 消息订阅',
        props: {
            staffId: {
                type: Number,
                default: null
            },
            eventMsgId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                bizEventMsg: {},
                goodsCatList: [],
                servcCatList: [],
                miniAppAliases: {},
                appAlias: null,
                bizEventMsgAppList: [],
                selectMiniApp: false,
                //
                comId: null,
                comName: null,
                showChangeStaff: true,  // 是否显示 选择员工
                staffInfo: {},
                thisStaffId: null,
                srcCatTypeList: {},
                //
                siteMsgFlag: true,
                emailFlag: true,
                wxFlag: true,
                //
                goodsCatForAll: false,
                servcCatForAll: false,
                thisComSelect: false,    // 不支持商品、服务时保存订阅
                btnState: false,    // 控制查看订阅按钮状态
                //
                saveFlag: false,    // 是否请求后台：如果用户未做任何操作，点击保存不请求后台
            }
        },
        created: function () {
            this.thisStaffId = this.staffId || null;
            //
            if(!Utils.isNoB(this.thisStaffId)) {
                this.showChangeStaff = false;   // 是否显示 选择员工
                //
                this.getMerchantStaffInfo();
            }
            // 获取事件消息信息
            this.getBizEventMsgInfo();
            this.getUserContext();
            this.existMsgSubscr();
            //
            this.getBizEventMsgAppList();
            //
            this.miniAppAliases = {
                "servicerEngin": "服务商服务工程师",
                "servicerServc": "服务商服务管理"
            };
            //
            this.srcCatTypeList = getEnumMap('srcCatType', 'value2text');
        },
        methods: {
            getUserContext: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    let scopeEntity = result.data.scopeEntity;
                    self.comId = scopeEntity.comId;
                    //
                    let eventData = {};
                    eventData.id = scopeEntity.comId;
                    eventData.name = scopeEntity.comName;
                    //
                    self.notityChange(eventData);
                });
            },
            existMsgSubscr(){     // 当前人、当前事件是否有订阅的消息-控制查看按钮显示
                let self = this;
                self.btnState = false;  // 重置状态
                //
                let postData = {};
                let filterItmes = {};
                filterItmes.staffId = this.thisStaffId;
                filterItmes.eventMsgId = this.eventMsgId;
                postData.filterItems = filterItmes;
                let theLoading = MsgBox.loading();
                bizMsgApi.getBizEventMsgSubscrList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let bizEventMsgSubscrList = result.data;
                        if(bizEventMsgSubscrList != null && bizEventMsgSubscrList.length > 0) {
                            self.btnState = true;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getBizEventMsgAppList: function () {
                let self = this;
                let postData = {};
                postData.eventMsgId = this.eventMsgId;
                postData.appMerchantType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizEventMsgAppList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let bizEventMsgAppList = result.data;
                        // 默认值处理 - 小程序， 未订阅设置默认选择的小程序，并且不默认[选择小程序]
                        if(Utils.isNoB(self.appAlias) && (bizEventMsgAppList != null && bizEventMsgAppList.length > 0)) {
                            self.appAlias = bizEventMsgAppList[0].appAlias;
                            //
                            self.selectMiniApp = false;     //
                        }
                        self.bizEventMsgAppList = bizEventMsgAppList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getMerchantStaffInfo: function () {
                let self = this;
                let postData = {};
                postData.id = this.thisStaffId;
                let theLoad = MsgBox.loading();
                servicerApi.getServicerStaff(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.staffInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getBizEventMsgInfo: function () {
                let self = this;
                let postData = {};
                postData.id = this.eventMsgId;
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizEventMsgInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.bizEventMsg = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取已订阅的信息
            getBizEventMsgSubscr: function () {
                let self = this;
                // 切换 公司重置 分类信息
                this.goodsCatList = [];
                this.servcCatList = [];
                this.thisComSelect = false; // 不支持服务商品、服务选择重置
                this.goodsCatForAll = false;
                this.servcCatForAll = false;
                // 重置 支持方式
                self.siteMsgFlag = true;
                self.emailFlag = true;
                self.wxFlag = true;
                self.selectMiniApp = false;
                //
                let postData = {};
                let filterItmes = {};
                filterItmes.staffId = this.thisStaffId;
                filterItmes.eventMsgId = this.eventMsgId;
                filterItmes.srcComId = this.comId;
                postData.filterItems = filterItmes;
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizEventMsgSubscrList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let bizEventMsgSubscrList = result.data;
                        //
                        bizEventMsgSubscrList.forEach(function (bizEventMsgSubscr) {
                            let catId = bizEventMsgSubscr.srcCatId;
                            let catId1 = bizEventMsgSubscr.srcCatId1;
                            let catId2 = bizEventMsgSubscr.srcCatId2;
                            let catId3 = bizEventMsgSubscr.srcCatId3;
                            let srcCatName = bizEventMsgSubscr.srcCatName;
                            //
                            // 确保当前事件小程序回显的正确，源公司与当前公司相同
                            if(self.comId == bizEventMsgSubscr.srcComId) {
                                self.appAlias = bizEventMsgSubscr.miniAppAlias;     // 回显选中的小程序
                                self.selectMiniApp = true;
                            }
                            //
                            if(bizEventMsgSubscr.srcCatType == 1) {  // 商品分类信息
                                if(catId == -1) { // 全选 -- 只可能有一条数据
                                    self.goodsCatForAll = true;
                                } else {
                                    let goodsCat = {};
                                    goodsCat.catId = catId;
                                    goodsCat.catId1 = catId1;
                                    goodsCat.catId2 = catId2;
                                    goodsCat.catId3 = catId3;
                                    goodsCat.catName = srcCatName;
                                    //
                                    self.goodsCatList.push(goodsCat);
                                }
                            } else if(bizEventMsgSubscr.srcCatType == 2) {   // 服务分类信息
                                if(catId == -1) { // 全选 -- 只可能有一条数据
                                    self.servcCatForAll = true;
                                } else {
                                    let servcCat = {};
                                    servcCat.catId = catId;
                                    servcCat.catId1 = catId1;
                                    servcCat.catId2 = catId2;
                                    servcCat.catId3 = catId3;
                                    servcCat.catName = srcCatName;
                                    //
                                    self.servcCatList.push(servcCat);
                                }
                            } else if(bizEventMsgSubscr.srcCatType == 0) {
                                // 无 --- 不支持 商品、服务分类时 - 只有一条数据
                                self.thisComSelect = true;
                            }
                        });
                        if(bizEventMsgSubscrList != null && bizEventMsgSubscrList.length > 0) {
                            // 回显 事件订阅的支持方式
                            let siteMsgFlag = bizEventMsgSubscrList[0].siteMsgFlag;     // list里的所有数据的siteMsgFlag、emailFlag 都是相同的。
                            let emailFlag = bizEventMsgSubscrList[0].emailFlag;
                            let wxFlag = bizEventMsgSubscrList[0].wxFlag;
                            self.siteMsgFlag = siteMsgFlag;
                            self.emailFlag = emailFlag;
                            self.wxFlag = wxFlag;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 商品分类选择
            goodsCatSet: function () {
                this.saveFlag = true;
                if(this.goodsCatForAll) { // 重置选择的分类信息
                    this.goodsCatList = [];
                }
            },
            goodsCatForselect: function () {
                let self = this;
                if(Utils.isNoB(this.thisStaffId)) {
                    MsgBox.warning('请选择员工!');
                    return;
                }
                let displayDataList = self.goodsCatList;
                let postData = {
                    multiSelect: true,
                };
                openMerchtFusedGoodsCategSelectDlg(postData, displayDataList, function (result) {
                    self.saveFlag = true;
                    let goodsCatList = [];
                    if(result.type == 'info') {
                        let resultData = result.data;
                        for(let i = 0; i < resultData.length; i++) {
                            let data = resultData[i];
                            let goodsCat = {};
                            goodsCat.catId = data.catId;
                            goodsCat.catId1 = data.catId1;
                            goodsCat.catId2 = data.catId2;
                            goodsCat.catId3 = data.catId3;
                            goodsCat.catName = data.catName;
                            goodsCatList.push(goodsCat);
                        }
                    }
                    self.goodsCatList = Utils.merge([], goodsCatList);
                });
            },
            // 服务分类选择
            servcCatSet: function () {
                this.saveFlag = true;
                if(this.servcCatForAll) { // 重置选择的分类信息
                    this.servcCatList = [];
                }
            },
            servcCatForselect: function () {
                let self = this;
                if(Utils.isNoB(this.thisStaffId)) {
                    MsgBox.warning('请选择员工!');
                    return;
                }
                let displayDataList = self.servcCatList || [];
                let postData = {
                    multiSelect: true,
                };
                openMerchtFusedServcCategSelectDlg(postData, displayDataList, function (result) {
                    self.saveFlag = true;
                    let servcCatList = [];
                    if(result.type == 'info') {
                        let resultData = result.data;
                        for(let i = 0; i < resultData.length; i++) {
                            let data = resultData[i];
                            let servcCat = {};
                            servcCat.catId = data.catId;
                            servcCat.catId1 = data.catId1;
                            servcCat.catId2 = data.catId2;
                            servcCat.catId3 = data.catId3;
                            servcCat.catName = data.catName;
                            servcCatList.push(servcCat);
                        }
                    }
                    self.servcCatList = Utils.merge([], servcCatList);
                });
            },
            // 选择员工
            staffForselect: function () {
                let self = this;
                openThisOrDownComStaffForSelectDlg(this.eventMsgId, function (resultData) {
                    self.saveFlag = false;
                    self.showChangeStaff = true;
                    self.thisStaffId = resultData.id;
                    //
                    self.getMerchantStaffInfo();
                    // 获取 - 订阅的分类信息
                    self.getBizEventMsgSubscr();
                    // 是否存在事件订阅
                    self.existMsgSubscr();
                });
            },
            // 公司选择
            notityChange: function (eventData) {
                this.saveFlag = false;
                this.comId = eventData.id;
                this.comName = eventData.name;
                if(!Utils.isNoB(this.thisStaffId)) {    // 未选择员工时 - 订阅的分类信息不确定是谁的
                    // 获取 - 订阅的分类信息
                    this.getBizEventMsgSubscr();
                }
            },
            // 查看已订阅的消息列表
            showEventMsgSubscrList: function () {
                let self = this;
                showEventMsgSubscrListDlg(this.thisStaffId, this.eventMsgId, function () {
                    // 点击关闭时，刷新界面
                    self.existMsgSubscr();
                    //
                    self.getBizEventMsgSubscr();
                });
            },
            changeSaveFlag: function () {
                this.saveFlag = true;
            },
            getDlgResult(){
                let result = {};
                result.type = 'info';
                if(this.thisStaffId == null) {
                    result.type = 'warn';
                    result.message = '请选择员工信息!';
                    return result;
                }
                if(!(this.siteMsgFlag || this.emailFlag || this.wxFlag)) {
                    result.type = 'warn';
                    result.message = '请选择事件支持方式!';
                    return result;
                }
                if(this.comId == null) {
                    result.type = 'warn';
                    result.message = '请选择业务源公司!';
                    return result;
                }
                let bizEventMsg = this.bizEventMsg;
                let goodsCatList = this.goodsCatList;
                let servcCatList = this.servcCatList;
                let goodsCatForAll = this.goodsCatForAll;
                let servcCatForAll = this.servcCatForAll;
                if(bizEventMsg.goodsRelated || bizEventMsg.servcRelated) {  // 不支持 商品、服务分类时，可直接保存
//                    let isPass = (goodsCatList != null && goodsCatList.length <= 0) && (servcCatList != null && servcCatList.length <= 0) && !goodsCatForAll && !servcCatForAll;
//                    if(isPass) {
//                        result.type = 'warn';
//                        result.message = '请选择分类!';
//                        return result;
//                    }
                } else {
                    if(!this.thisComSelect) {
                        this.thisComSelect = true;
                    } else {
                        result.type = 'warn';
                        result.message = '已订阅-当前机构!';
                        return result;
                    }
                }

                // 设置数据
                let data = {};
                data.staffId = this.thisStaffId;
                data.staffName = this.staffInfo.name;
                data.eventMsgId = this.eventMsgId;
                data.srcComId = this.comId;
                if(Utils.isNoB(goodsCatList) || goodsCatList.length <= 0) {
                    data.goodsCatIds = [];
                } else {
                    data.goodsCatIds = goodsCatList.pluck('catId');
                }
                if(Utils.isNoB(servcCatList) || servcCatList.length <= 0) {
                    data.servcCatIds = [];
                } else {
                    data.servcCatIds = servcCatList.pluck('catId');
                }
                //
                data.siteMsgFlag = this.siteMsgFlag;
                data.emailFlag = this.emailFlag;
                data.wxFlag = this.wxFlag;
                if(this.wxFlag && this.selectMiniApp) {
                    //
                    data.miniAppAlias = this.appAlias;
                } else {
                    data.miniAppAlias = "";     // 未支持微信发送 - 取消小程序别名设置
                }
                //
                data.goodsCatForAll = goodsCatForAll;
                data.servcCatForAll = servcCatForAll;
                //
                let saveFlag = this.saveFlag;
                if(saveFlag) {
                    console.log("------------ 请求后台保存！！ ------------");
                } else {
                    console.log("------------ 未修改信息，不请求后台！！ ------------");
                }
                data.saveFalg = saveFlag;
                result.data = data;
                // 保存订阅成功，即可查看已订阅信息
                this.btnState = true;
                this.saveFlag = false;
                //
                return result;
            }
        }
    }
</script>

<style>
    .msg-subscr .tree-structure-collapse + .el-tree {
        margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/compo/bizMsg/MsgSubscrDlg.vue